<template>
  <v-menu bottom left :offset-y="true">
    <template #activator="{ on, attrs }">
      <v-btn
        outlined small color="primary" class="action-btn elevation-0 rounded-lg d-flex justify-space-between"
        height="32"
        v-bind="attrs"
        v-on="on"
        @click="getAvailableStatuses(); active = !active;"
      >
        {{ name }}
        <div class="d-flex align-center">
          <v-icon
            class="uikit-icon chevron-down primary size-24 delay-03"
            :class="attrs['aria-expanded'] === 'true' ? 'to-switch-direction' : ''"
          />
        </div>
      </v-btn>
    </template>

    <v-list class="pt-1 pb-1" min-width="200" max-width="300">
      <UIProgressCircular v-if="statusListLoading" class="mb-6" />

      <template v-for="(status, index) of availableStatusList">
        <v-divider v-if="index !== 0" :key="status.id + 'divider'" />
        <ListItemButton :key="status.id + 'ListItemButton'" :title="status.name" @click="changeFilledFormStatus(status)" />
      </template>

      <v-list-item v-if="!availableStatusList.length && !statusListLoading" dense class="list-item">
        <v-list-item-title class="list-item-text">
          <span>Нет доступных действий</span>
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import ListItemButton from '@/featureSlicedDesign/entites/ListItemButton'
import { FilledFormStatus } from '@/enums'
import { filledFormApi } from '@/api'
import UIProgressCircular from '@/ui/progress/UIProgressCircular'

export default {
  name: 'MenuButton',

  components: { UIProgressCircular, ListItemButton },

  props: {
    name: {
      type: String,
      default: '',
    },
    filledFormId: {
      type: Number,
      required: true,
    },
  },

  data: () => ({
    FilledFormStatus,
    active: false,

    availableStatusList: [],

    statusListLoading: false,
  }),

  methods: {
    async getAvailableStatuses() {
      try {
        if (!this.availableStatusList.length) {
          this.statusListLoading = true
          this.availableStatusList = await filledFormApi.findAchievableStatuses(this.filledFormId)
        }
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка получения доступных статусов')
      } finally {
        this.statusListLoading = false
      }
    },

    changeFilledFormStatus(status) {
      if (status.isCommentNeeded) {
        this.$emit('sendToRevision', status.id)
      } else {
        this.$emit('changeFilledFormStatus', status.id)
      }
    },
  },

  watch: {
    name() {
      this.availableStatusList = []
    },
  },
}
</script>

<style lang="scss" scoped>
.to-switch-direction {
  transform: rotate(180deg)
}

.action-btn {
  width: 100%;
  min-width: 200px;
  max-width: 300px;
}
</style>
